// extracted by mini-css-extract-plugin
module.exports = {"archidektOrange":"#fa890d","quantityBlue":"#698bc7","quantityGreen":"#1ebb6c","flex":"flair_flex__5YtZD","flair":"flair_flair__V2vjH","pulse":"flair_pulse__XHKmj"};